module.exports = __webpack_public_path__ + "img/HR_share.4f60dbb7.jpg";